import { render } from "./EditPayGrade.vue?vue&type=template&id=3a9d2a90"
import script from "./EditPayGrade.vue?vue&type=script&lang=js"
export * from "./EditPayGrade.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__